import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, RouterOutlet, RouterLinkActive, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { ShortenPipe } from '../../pipes/shorten.pipe';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
    ShortenPipe
  ],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.css'
})
export class PrivacyComponent {
  // Dependency Injection  
  router: Router = inject(Router);
  toastrService: ToastrService = inject(ToastrService);
  authService = inject(AuthService);

  // User Authentication
  authenticatedUser = this.authService.authenticatedUser;
  authToken?: string;

  ngOnInit(): void {
    
  }
}